import defaultAttributes from '../defaultAttributes';

const Mountain = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M8 3l4 8 5-5 5 15H2L8 3z' }]],
];

export default Mountain;
